import { Spinner } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

export const StyledSpinner = ({ variant }: { variant: 'default' | 'x-large' | 'large' }): React.ReactElement => {
	const SpinnerContainer = styled.div`
		background-color: white;
		padding: 44px 31px;
		flex: auto;
		text-align: center;
		width: 100%;
		margin-top: 10%;

		@media screen and (min-width: 560px) {
			padding: 52px 46px;
		}

		@media screen and (min-width: 960px) {
			padding: var(--size-grid001);
		}
	`;

	return (
		<SpinnerContainer>
			<Spinner variant={variant} />
		</SpinnerContainer>
	);
};
